import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { HvEmptyState, HvButton } from "@hitachivantara/uikit-react-core";
import { Info } from "@hitachivantara/uikit-react-icons";

import useStyles from "./styles";

const NotFound: React.FC = () => {
  const { t } = useTranslation("common");
  const history = useHistory();
  const classes = useStyles();

  return (
    <HvEmptyState
      classes={{ root: classes.root }}
      title={t("notFound.title")}
      message={t("notFound.message")}
      action={
        <HvButton category="ghost" onClick={() => history.goBack()}>
          {t("notFound.action")}
        </HvButton>
      }
      icon={<Info role="presentation" />}
    />
  );
};

export default NotFound;
